<div class="row devOptions" *ngIf="showDevOptions&&devOptionsRight">
    <div class="p-4 w-100">
        <div class="w-100">
            <h4 class="ml-3" style="font-weight: 600">{{'common_all_decode' | i18n}} </h4>
            <i class="fa fa-window-minimize margin-top-10 margin-right-8" (click)="showDevOptions=false" style="cursor: pointer; position: absolute; right: 10px; top: 5px;"></i>
        </div>
        <div class="clearfix"></div>
        <div class="w-100" style="font-size: 14px;padding: 10px 0;">
            <div class="row mx-0 d-flex flex-column flex-md-row">
                <div class="col-xs-12 mb-3 d-flex flex-column">
                    <label for="host-field"  class="comapnyLbl ediLbl">{{'Host' | i18n}}</label>
                    <label id="host-field" class="feildLbl" >
                        <input type="text" class="form-control dashbaordlabel "  [(ngModel)]="host">
                    </label>                    
                </div>
                <div class="col-xs-12 mb-3 d-flex flex-column">
                    <label for="topic-field"  class="comapnyLbl ediLbl">{{'Topic' | i18n}}</label>
                    <label id="topic-field" class="feildLbl" >
                        <input type="text" class="form-control dashbaordlabel "  [(ngModel)]="topic">
                    </label>
                </div>
                <div class="col-xs-12 mb-3 d-flex flex-column">
                    <label for="path-field"  class="comapnyLbl ediLbl">{{'Path' | i18n}}</label>
                    <label id="path-field" class="feildLbl" >
                        <input type="text" class="form-control dashbaordlabel "  [(ngModel)]="path">
                    </label>
                    
                </div>
            </div>
        </div>
        <hr>
        <div class="col-sm-12 text-right mb-4">
            <footer>
            <button title="{{'common_clear' | i18n}}" (click)="clear()"
                class="itemEditButton"  style="font-size: 14px;">{{'common_clear' | i18n}}</button>
            <button title="{{'common_submit' | i18n}}" type="button" (click)="checkKafka()"
                class="itemEditButton ml-4" style="font-size: 14px;">{{'common_submit' | i18n}}</button>
            </footer>
        </div>
    </div>
</div>
<div class="row devOptions"  *ngIf="showDecryptOptions">
    <div class="p-4 w-100">
        <div class="w-100">
            <h4 class="ml-3" style="font-weight: 600">{{'common_all_decode' | i18n}} </h4>
            <i class="fa fa-window-minimize margin-top-10 margin-right-8" (click)="showDecryptOptions=false" style="cursor: pointer; position: absolute; right: 10px; top: 5px;"></i>
        </div>
        <div class="clearfix"></div>
        <div class="w-100" style="font-size: 14px;">
            <textarea class="decodeTextArea m-3" id="encrypted" placeholder="{{'common_all_encryptedData' | i18n}}"></textarea>
            <textarea class="decodeTextArea m-3" id="decrypted" placeholder="{{'common_all_result' | i18n}}" disabled></textarea>
        </div>
        <hr>
        <div class="col-sm-12 text-right mb-4">
            <footer>
            <button title="{{'common_clear' | i18n}}" (click)="clearForm()"
                class="itemEditButton"  style="font-size: 14px;">{{'common_clear' | i18n}}</button>
            <button title="{{'common_submit' | i18n}}" (click)="decode()" type="button"
                class="itemEditButton ml-4" style="font-size: 14px;"><i class="fa fa-spinner fa-spin"
                *ngIf="addStatus"></i>{{'common_submit' | i18n}}</button>
            </footer>
        </div>
    </div>
</div>
<div class="page-footer theme-bg-color w-100">
    <!-- <div class="row"> -->

    <!-- </div> -->
    <div class="row my-2 mx-1">
        <!-- <div class="col-xs-2 col-sm-2 col-md-2 col-lg-2 iconItems">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 helpIcon">
               <div><i class="fa fa-question-circle" aria-hidden="true" style="color: white;font-size: 20x;"></i><span style="font-size: 14px;color: #4b515a;padding-left: 10px;">Help</span></div>
            </div>
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <sa-logout></sa-logout>
            </div>
        </div> -->
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 px-0">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-8">
                <div class="row">
                    <ul class="footerItems footerTextColor">
                        <li>
                            <span class="li-footer__copy-text">© {{year}} </span>
                            <span class="footerTxt">iomarket</span>
                        </li>
                        <li class="footerContent">
                            <a href="https://www.io-market.com/AGB.pdf" target="_blank"> <span class="li-footer__copy-text">{{'common_all_terms_and_conditions' | i18n}}</span></a>

                        </li>
                        <li class="footerContent">
                            <a href="https://www.io-market.com/ADV.pdf" target="_blank"> <span class="li-footer__copy-text">{{'common_all_data_processing_agreement' | i18n}}</span></a>

                        </li>
                        <li class="footerContent" >
                            <a href="https://www.io-market.com/privacy_policy.pdf" target="_blank"><span class="li-footer__copy-text">{{'common_all_privacy_policy' | i18n}}</span></a>

                        </li>
                        <li class="footerContent">
                            <a href="https://www.io-market.com/impressum.pdf" target="_blank"> <span class="li-footer__copy-text">{{'common_all_legal_notices' | i18n}}</span></a>

                        </li>
                    </ul>
                </div>
                <!-- <span class="txt-color-white">SmartAdmin 1.9.0 - Web Application Framework © 2017-2019</span> -->
            </div>
            <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 px-0 hidden-xs d-sm-none  d-md-none d-lg-block">
                <a title="{{'common_all_footer_devOptions' | i18n}}" (click)="openDevOption()" class="itemEditButton" id="reset-smart-widget" style="position: absolute;bottom: -22px;right: 155px;"  *ngIf="devOptionsRight">
                    <span class="decode">{{'common_all_footer_devOptions' | i18n}}</span>
                </a>
                <a title="{{'common_all_footer_devOptions' | i18n}}" (click)="openDecryptOption()" class="itemEditButton" id="reset-smart-widget" style="position: absolute;bottom: -22px;right: 5px;">
                    <span class="decode">{{'common_all_footer_devOptions' | i18n}}</span>
                </a>
            </div> 

            <!-- <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-right hidden-xs d-sm-none d-lg-block .d-xl-block">
                <div class="txt-color-white inline-block">

                    <div class="btn-group" dropdown dropup="true">
                        <ul class="dropdown-menu" *dropdownMenu style="right: 0px; left: auto">
                            <li>
                                <div class="padding-5">
                                    <p class="txt-color-darken font-sm no-margin">Download Progress</p>

                                    <div class="progress progress-micro no-margin">
                                        <div class="progress-bar progress-bar-success" style="width: 50%;"></div>
                                    </div>
                                </div>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <div class="padding-5">
                                    <p class="txt-color-darken font-sm no-margin">Server Load</p>

                                    <div class="progress progress-micro no-margin">
                                        <div class="progress-bar progress-bar-success" style="width: 20%;"></div>
                                    </div>
                                </div>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <div class="padding-5">
                                    <p class="txt-color-darken font-sm no-margin">Memory Load <span class="text-danger">*critical*</span>
                                    </p>

                                    <div class="progress progress-micro no-margin">
                                        <div class="progress-bar progress-bar-danger" style="width: 70%;"></div>
                                    </div>
                                </div>
                            </li>
                            <li class="divider"></li>
                            <li>
                                <div class="padding-5">
                                    <button class="btn btn-block btn-default">refresh</button>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</div>